import LocalizedStrings from "react-localization";
import type { Branding } from "@/types/Branding";
import English from "./languages/en";

const translations = {
  en: English,
};

const Strings = new LocalizedStrings(translations);

const interpolateBranding = (
  value: unknown,
  replacements: Record<string, string>,
): unknown => {
  if (typeof value === "string") {
    return Object.entries(replacements).reduce(
      (result, [placeholder, replacement]) =>
        result.split(`:${placeholder}`).join(replacement),
      value,
    );
  }

  if (Array.isArray(value)) {
    return value.map((item) =>
      interpolateBranding(item, replacements),
    );
  }

  if (value !== null && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        interpolateBranding(nestedValue, replacements),
      ]),
    );
  }

  return value;
};

const configureBrandingStrings = (branding: Branding): void => {
  const replacements: Record<string, string> = {
    brand_name: branding.short_name,
    product_name: branding.regulated_product_name,
    legal_name: branding.legal.name,
    copyright_name:
      branding.legal.copyright_name,
    support_email: branding.contact.support_email,
    billing_email: branding.contact.billing_email,
    sales_email: branding.contact.sales_email,
    phone: branding.contact.phone,
    address_line_1: branding.address.line_1,
    address_line_2: branding.address.line_2!,
    address_city: branding.address.city,
    address_state: branding.address.state,
    address_postal_code: branding.address.postal_code,
    address_country: branding.address.country!,
  };

  Strings.setContent(
    interpolateBranding(translations, replacements),
  );
};

export { Strings, configureBrandingStrings };